Prism.languages.liquid = {
  comment: {
    pattern: /(^\{%\s*comment\s*%\})[\s\S]+(?=\{%\s*endcomment\s*%\}$)/,
    lookbehind: !0
  },
  delimiter: {
    pattern: /^\{(?:\{\{|[%\{])-?|-?(?:\}\}|[%\}])\}$/,
    alias: "punctuation"
  },
  string: {
    pattern: /"[^"]*"|'[^']*'/,
    greedy: !0
  },
  keyword: /\b(?:as|assign|break|(?:end)?(?:capture|case|comment|for|form|if|paginate|raw|style|tablerow|unless)|continue|cycle|decrement|echo|else|elsif|in|include|increment|limit|liquid|offset|range|render|reversed|section|when|with)\b/,
  object: /\b(?:address|all_country_option_tags|article|block|blog|cart|checkout|collection|color|country|country_option_tags|currency|current_page|current_tags|customer|customer_address|date|discount_allocation|discount_application|external_video|filter|filter_value|font|forloop|fulfillment|generic_file|gift_card|group|handle|image|line_item|link|linklist|localization|location|measurement|media|metafield|model|model_source|order|page|page_description|page_image|page_title|part|policy|product|product_option|recommendations|request|robots|routes|rule|script|search|selling_plan|selling_plan_allocation|selling_plan_group|shipping_method|shop|shop_locale|sitemap|store_availability|tax_line|template|theme|transaction|unit_price_measurement|user_agent|variant|video|video_source)\b/,
  function: [{
    pattern: /(\|\s*)\w+/,
    lookbehind: !0,
    alias: "filter"
  }, {
    pattern: /(\.\s*)(?:first|last|size)/,
    lookbehind: !0
  }],
  boolean: /\b(?:false|nil|true)\b/,
  range: {
    pattern: /\.\./,
    alias: "operator"
  },
  number: /\b\d+(?:\.\d+)?\b/,
  operator: /[!=]=|<>|[<>]=?|[|?:=-]|\b(?:and|contains(?=\s)|or)\b/,
  punctuation: /[.,\[\]()]/,
  empty: {
    pattern: /\bempty\b/,
    alias: "keyword"
  }
}, Prism.hooks.add("before-tokenize", function (e) {
  var t = !1;
  Prism.languages["markup-templating"].buildPlaceholders(e, "liquid", /\{%\s*comment\s*%\}[\s\S]*?\{%\s*endcomment\s*%\}|\{(?:%[\s\S]*?%|\{\{[\s\S]*?\}\}|\{[\s\S]*?\})\}/g, function (e) {
    var n = /^\{%-?\s*(\w+)/.exec(e);
    if (n) {
      var i = n[1];
      if ("raw" === i && !t) return t = !0, !0;
      if ("endraw" === i) return t = !1, !0;
    }
    return !t;
  });
}), Prism.hooks.add("after-tokenize", function (e) {
  Prism.languages["markup-templating"].tokenizePlaceholders(e, "liquid");
});